/**
 * Client-side premove helpers (no server state).
 */
import { Chess } from 'chess.js';

function forceSideToMove(fen, color) {
  const parts = fen.split(' ');
  if (parts.length < 2) return fen;
  parts[1] = color;
  return parts.join(' ');
}

export function isLegalPremove(chessJs, myColor, from, to, promotion = 'q') {
  if (!chessJs || !myColor || !from || !to) return false;
  const piece = chessJs.get(from);
  if (!piece || piece.color !== myColor) return false;
  try {
    const forced = new Chess(forceSideToMove(chessJs.fen(), myColor));
    const mv = forced.move({ from, to, promotion });
    return Boolean(mv);
  } catch {
    return false;
  }
}

export function premoveOptionSquares(chessJs, myColor, from) {
  if (!chessJs || !myColor || !from) return null;
  const piece = chessJs.get(from);
  if (!piece || piece.color !== myColor) return null;
  let forced;
  try {
    forced = new Chess(forceSideToMove(chessJs.fen(), myColor));
  } catch {
    return null;
  }
  const moves = forced.moves({ square: from, verbose: true });
  if (!moves.length) return null;
  const next = {};
  moves.forEach((m) => {
    next[m.to] = {
      background: m.captured
        ? 'radial-gradient(circle, rgba(220,38,38,.35) 36%, transparent 40%)'
        : 'radial-gradient(circle, rgba(59,130,246,.45) 24%, transparent 26%)',
    };
  });
  next[from] = { background: 'rgba(59,130,246,.35)' };
  return next;
}

export function premoveSquareStyles(premove) {
  if (!premove?.from || !premove?.to) return {};
  return {
    [premove.from]: { background: 'rgba(37,99,235,.45)' },
    [premove.to]: { background: 'rgba(37,99,235,.35)' },
  };
}
